// DO NOT CHANGE THE ORDER OF THIS ARRAY WITHOUT VERIFYING AGAINST ContentManagement.Dto.Enums.Region
export const Regions = Object.freeze([
	// { key: 'ALL', label: 'All Regions' }, // unused "ALL" key - IF UNCOMMENTED, MUST UPDATE RegionValues
	{ key: 'AL', label: 'Alabama' },
	{ key: 'AK', label: 'Alaska' },
	{ key: 'AZ', label: 'Arizona' },
	{ key: 'AR', label: 'Arkansas' },
	{ key: 'CA', label: 'California (All counties)' },
	{ key: 'CASpecificCounties', label: 'California (Specific counties)' },
	{ key: 'CAOtherCounties', label: 'California (Other counties)' },
	{ key: 'CO', label: 'Colorado' },
	{ key: 'CT', label: 'Connecticut' },
	{ key: 'DE', label: 'Delaware' },
	{ key: 'DC', label: 'District of Columbia' },
	{ key: 'FL', label: 'Florida' },
	{ key: 'GA', label: 'Georgia' },
	{ key: 'HI', label: 'Hawaii' },
	{ key: 'ID', label: 'Idaho' },
	{ key: 'IL', label: 'Illinois' },
	{ key: 'IN', label: 'Indiana' },
	{ key: 'IA', label: 'Iowa' },
	{ key: 'KS', label: 'Kansas' },
	{ key: 'KY', label: 'Kentucky' },
	{ key: 'LA', label: 'Louisiana' },
	{ key: 'ME', label: 'Maine' },
	{ key: 'MD', label: 'Maryland' },
	{ key: 'MA', label: 'Massachusetts' },
	{ key: 'MI', label: 'Michigan' },
	{ key: 'MN', label: 'Minnesota' },
	{ key: 'MS', label: 'Mississippi' },
	{ key: 'MO', label: 'Missouri' },
	{ key: 'MT', label: 'Montana' },
	{ key: 'NE', label: 'Nebraska' },
	{ key: 'NV', label: 'Nevada' },
	{ key: 'NH', label: 'New Hampshire' },
	{ key: 'NJ', label: 'New Jersey' },
	{ key: 'NM', label: 'New Mexico' },
	{ key: 'NY', label: 'New York' },
	{ key: 'NC', label: 'North Carolina' },
	{ key: 'ND', label: 'North Dakota' },
	{ key: 'OH', label: 'Ohio' },
	{ key: 'OK', label: 'Oklahoma' },
	{ key: 'OR', label: 'Oregon' },
	{ key: 'PA', label: 'Pennsylvania' },
	{ key: 'RI', label: 'Rhode Island' },
	{ key: 'SC', label: 'South Carolina' },
	{ key: 'SD', label: 'South Dakota' },
	{ key: 'TN', label: 'Tennessee' },
	{ key: 'TX', label: 'Texas' },
	{ key: 'UT', label: 'Utah' },
	{ key: 'VA', label: 'Virginia (Full State)' },
	{ key: 'VAEast', label: 'Virginia (East)' },
	{ key: 'VAWest', label: 'Virginia (West)' },
	{ key: 'VI', label: 'Virgin Islands' },
	{ key: 'VT', label: 'Vermont' },
	{ key: 'WA', label: 'Washington' },
	{ key: 'WV', label: 'West Virginia' },
	{ key: 'WI', label: 'Wisconsin' },
	{ key: 'WY', label: 'Wyoming' },
]);

export const RegionValues = Object.freeze(
	Regions.reduce((acc, region, index) => {
		acc[region.key] = index + 2; // plus 1 to account for unused "ALL" key
		return acc;
	}, {})
);
